import StyledNavbarLayout from './navbar/components/StyledNavbarLayout';
import { useDashboardLayout } from './navbar/hooks/useDashboardLayout';

export function DashboardLayout() {
  const { navConfig } = useDashboardLayout();
  return <StyledNavbarLayout navConfig={navConfig} />;
}
